// ** React Imports
import { lazy } from 'react';

const List = lazy(() => import('../../views/admins'));

const Routes = [
  {
    element: <List />,
    path: '/administrators/list',
    meta: {
      permission: 'ADMINS'
    }
  }
];

export default Routes;
